import { Suspense, lazy } from "react";
import "./App.css";
import Navbar from "./Component/Navbar/Navbar";
import Footer from "./Component/Footer/Footer";
import { Routes, Route } from "react-router-dom";

const Home = lazy(() => import("./Component/Pages/Home/Home"));
const FeatureGrid = lazy(() => import("./Component/Pages/Feature/FeatureGrid"));
const Pricing = lazy(() => import("./Component/Pages/Pricing/Pricing"));
const Contact = lazy(() => import("./Component/Pages/Contactus/Contact_us"));
const DigitalMarketing = lazy(() => import("./Component/Pages/Home/DigitalMarketing"));
const DigitalExamination = lazy(() => import("./Component/Pages/Home/DigitalExamination"));
const ErpPlatform = lazy(() => import("./Component/Pages/Home/ErpPlatform"));
const SmartCampus = lazy(() => import("./Component/Pages/Home/SmartCampus"));

function RouteFallback() {
  return <div className="route-shell route-loading" aria-hidden="true" />;
}

function App() {
  return (
    <>
      <Navbar />
      <div className="nav-spacer" />

      <Suspense fallback={<RouteFallback />}>
        <div className="route-shell">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/features" element={<FeatureGrid />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/digital-marketing" element={<DigitalMarketing />} />
            <Route path="/digital-examination" element={<DigitalExamination />} />
            <Route path="/ErpPlatform" element={<ErpPlatform />} />
            <Route path="/SmartCampus" element={<SmartCampus />} />
          </Routes>
        </div>
      </Suspense>

      <Footer />
    </>
  );
}

export default App;
